export default __webpack_public_path__ + "static/media/Baleloader.5c694383.jpg";